import { decrementRequests, incrementRequests } from 'api/fetcher';
import axios, { AxiosResponse } from 'axios';

type NewLeadsResponse = {
    count: number;
};

const newLeadsUrl = '/api/v1/leads/count';

const getNewLeads = async (): Promise<number> => {
    try {
        const instance = axios.create();
        instance.defaults.timeout = 0;
        incrementRequests();
        const response: AxiosResponse<NewLeadsResponse> = await instance.get(newLeadsUrl);
        return response.data.count;
    } catch (e) {
        throw e;
    } finally {
        decrementRequests();
    }
};

export default getNewLeads;
